import { getQuestionArea, getQuestionDesc, getUserList } from '../../api'
import useRequest from '@ahooksjs/use-request'

export const useQuestionDesc = (id: string) => useRequest(() => getQuestionDesc(id))

export const useQuestionArea = (id: string) => useRequest(() => getQuestionArea(id))


export const useUserList = () => useRequest(getUserList, { manual: true })
